import { forwardRef, useEffect, useRef } from 'react';

import * as S from './styled/Checkbox.styled';

const Checkbox = (props, ref) => {
	const { indeterminate, ...rest } = props;
	const defaultRef = useRef();
	const resolvedRef = ref || defaultRef;

	useEffect(() => {
		resolvedRef.current.indeterminate = indeterminate;
	}, [resolvedRef, indeterminate]);

	return (
		<S.Checkbox
			ref={resolvedRef}
			className={`${props.error ? 'error' : ''} ${props.className ? props.className : ''}`}
			type="checkbox"
			{...rest}
		/>
	);
};

export default forwardRef(Checkbox);
